import { render, staticRenderFns } from "./TabAccountSetting.vue?vue&type=template&id=0ca13c3e&scoped=true&"
import script from "./TabAccountSetting.vue?vue&type=script&lang=js&"
export * from "./TabAccountSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca13c3e",
  null
  
)

export default component.exports